import { useState, type ReactNode } from "react";

interface InputProps {
  children?: ReactNode;
  name: string; // Label text
  type?: "email" | "password" | "text" | "tel" | "number"; // HTML input type
  placeholder?: string;
  disabled?: boolean;

  // Form control properties
  value?: string; // Controlled component value
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  // Validation properties
  error?: string; // Error message to display
  isValid?: boolean; // Whether field passes validation
  required?: boolean;

  // Accessibility
  id?: string;
  ariaLabel?: string;
  ariaDescribedBy?: string;

  // Styling
  className?: string;
}
const Input: React.FC<InputProps> = ({
  children,

  name,
  type = "text",
  placeholder,
  disabled = false,
  value,
  onChange,
  onBlur,
  error,
  isValid,
  required = false,
  id,
  ariaLabel,
  ariaDescribedBy,
  className = "",
}) => {
  const [revealPassword, setRevealPassword] = useState(false);
  const inputId = id || `input-${name.toLowerCase().replace(/\s+/g, "-")}`;
  const errorId = `${inputId}-error`;

  const inputClasses = [
    "input",
    className,
    error && "input--error",
    isValid && "input--valid",
    disabled && "input--disabled",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="input__wrapper">
      <div className="input__top">
        <label htmlFor={inputId} className="input__label">
          {name}
          {/* {required && <span className="input__required">*</span>} */}
        </label>

        {children}
      </div>
      <div className="input__box">
        <div className={inputClasses}>
          <input
            className="input__type"
            id={inputId}
            type={revealPassword && type === "password" ? "text" : type}
            placeholder={placeholder}
            disabled={disabled}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            required={required}
            aria-label={ariaLabel || name}
            aria-describedby={error ? errorId : ariaDescribedBy}
            aria-invalid={!!error}
          />
        </div>
        {type === "password" && !disabled && (
          <button
            className={`input__reveal ${revealPassword && "active"}`}
            onClick={(e) => (
              e.preventDefault(), setRevealPassword(!revealPassword)
            )}
          ></button>
        )}
      </div>
      {error && (
        <p
          id={errorId}
          className={`input__error ${error && "input__error--show"}`}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
